import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { apiService } from '../services/api';

const ApiDebugger: React.FC = () => {
  const [results, setResults] = useState<string[]>([]);

  const addResult = (message: string) => {
    setResults(prev => [...prev, `${new Date().toISOString()}: ${message}`]);
  };

  const testGetProjects = async () => {
    try {
      addResult('Testing GET /api/projects...');
      const projects = await apiService.getProjects();
      addResult(`Success! Found ${projects.length} projects`);
      console.log('Projects:', projects);
    } catch (error: unknown) {
      addResult(`Error: ${error instanceof Error ? error.message : String(error)}`);
      console.error('Error:', error);
    }
  };

  const testCreateProject = async () => {
    try {
      const testName = `Test Project ${Date.now()}`;
      addResult(`Testing POST /api/projects with name: ${testName}...`);
      const project = await apiService.createProject({ name: testName });
      addResult(`Success! Created project with ID: ${project.id}`);
      console.log('Created project:', project);
    } catch (error: unknown) {
      addResult(`Error: ${error instanceof Error ? error.message : String(error)}`);
      console.error('Error:', error);
    }
  };

  const testDeleteProject = async () => {
    try {
      // First create a project to delete
      const testName = `Delete Test ${Date.now()}`;
      addResult(`Creating project to delete: ${testName}...`);
      const project = await apiService.createProject({ name: testName });
      addResult(`Created project with ID: ${project.id}`);
      
      // Now delete it
      addResult(`Testing DELETE /api/projects/${project.id}...`);
      await apiService.deleteProject(project.id);
      addResult(`Success! Deleted project ${project.id}`);
    } catch (error: unknown) {
      addResult(`Error: ${error instanceof Error ? error.message : String(error)}`);
      console.error('Error:', error);
    }
  };

  const testHealthEndpoint = async () => {
    try {
      addResult('Testing /api/projects/health...');
      const baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://munca-la-schimb-production.up.railway.app/api';
      const response = await fetch(`${baseUrl}/projects/health`);
      const data = await response.json();
      addResult(`Health check response: ${JSON.stringify(data)}`);
    } catch (error: unknown) {
      addResult(`Error: ${error instanceof Error ? error.message : String(error)}`);
      console.error('Error:', error);
    }
  };

  const clearResults = () => {
    setResults([]);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>API Debugger</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2 flex-wrap">
          <Button onClick={testGetProjects} variant="outline">
            Test GET Projects
          </Button>
          <Button onClick={testCreateProject} variant="outline">
            Test CREATE Project
          </Button>
          <Button onClick={testDeleteProject} variant="outline">
            Test DELETE Project
          </Button>
          <Button onClick={testHealthEndpoint} variant="outline">
            Test Health Endpoint
          </Button>
          <Button onClick={clearResults} variant="destructive">
            Clear Results
          </Button>
        </div>
        
        <div className="mt-4 p-4 bg-gray-100 rounded">
          <h3 className="font-bold mb-2">Results:</h3>
          <div className="space-y-1 font-mono text-sm">
            {results.length === 0 ? (
              <p className="text-gray-500">No results yet. Click a button to test.</p>
            ) : (
              results.map((result, index) => (
                <div key={index} className="text-xs">
                  {result}
                </div>
              ))
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApiDebugger;